import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:'AIzaSyBX3tJlkm_eSWDBNExwOxA4tcIrl6cH0ZM',
  authDomain: "sosahome-e16bc.firebaseapp.com",
  databaseURL: "https://sosahome-e16bc-default-rtdb.firebaseio.com",
  projectId: "sosahome-e16bc",
  storageBucket: "sosahome-e16bc.appspot.com",
  messagingSenderId: "810089113510",
  appId: "1:810089113510:web:5a4581d942e5f165671167"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth()
export const db = getDatabase(app)